<template>
    <modal
        name="hero-video-modal"
        width="90%"
        :maxWidth="1295"
        height="auto"
        :adaptive="true"
        :scrollable="true"
    >
        <div class="hero-video-modal">
            <span class="icon-cancel hero-video-modal__close-button" @click="closeModal"></span>
            <iframe
                class="embed-video"
                type="text/html"
                :src="videoSrc + '?autoplay=1'"
                frameborder="0"
                mozallowfullscreen
                webkitallowfullscreen
                allowfullscreen
                allow="autoplay; fullscreen"
                ref="vimeoPlayer"
                width="100%"
                height="100%"
            />
        </div>
    </modal>
</template>

<script>
export default {
    name: 'hero-video-modal',
    props: {
        videoSrc: {
            type: String
        }
    },
    methods: {
        closeModal () {
            this.$modal.hide('hero-video-modal')
        }
    }
}
</script>

<style lang="scss" scoped>
    .hero-video-modal {
        padding: 14px 20px 20px;
        width: 100%;
        height: 100%;
        max-height: 780px;
        border-radius: 15px;
        display: flex;
        flex-direction: column;

        &__close-button {
            align-self: flex-end;
            font-size: 3rem;
            margin: 0 0 12px;
        }
    }
    .embed-video {
        width: 100%;
        height: 780px;
    }
</style>

<style lang="scss">
[data-modal=hero-video-modal] {
    .v--modal-box.v--modal {
        border-radius: 15px !important;
    }
}
</style>
